import { svgSprite } from '../../../../hybrid/wrappers';
import { t } from '../../../../common/components/T';
import css from './PreviewButtons.module.scss';
import classnames from 'classnames';
import { useState, useEffect, useCallback } from 'react';
import { WindowScrollDimensions } from '../../../../common/utils/windowDimensions';

const PreviewButtons = ({ mobile, admin, translatesData, template, widthDimensions }) => {
    const [stateShowMenuOffice, setstateShowMenuOffice] = useState(true);

    const handler = useCallback(() => {
        const isShown =
            document.querySelector('#bottom_office_menu') &&
            document.querySelector('#bottom_office_menu').dataset.visible === 'true';
        setstateShowMenuOffice(isShown);
    }, []);
    useEffect(() => {
        WindowScrollDimensions(handler);
        return () => {
            WindowScrollDimensions(handler, true);
        };
    }, [handler]);

    return (
        <div
            style={template === 'templatecabinet' && !widthDimensions < 768 ? { marginLeft: 'auto' } : {}}
            className={classnames(
                widthDimensions < 768 ? (stateShowMenuOffice ? css.mobileButtonShowMenu : css.mobileButton) : null
            )}
        >
            <div style={{ padding: '0 12px' }}>
                <div className={css.eyeWrapper}>
                    {svgSprite('eye-system', {
                        className: css.formInputHelpBtnSvg
                    })}
                    <p className={css.titleAdminText}>
                        {t('admin_preview_breadcrumbs', 'Страница предпросмотра', '/page', translatesData)}
                    </p>
                </div>
                <div className={classnames(css.buttonAdminImg, css.buttonAdminSquare)} onClick={() => admin(false)}>
                    {mobile ? (
                        <div className={css.buttonAdminSquareWrapper}>
                            {t('pagemanagementButtonSquare-back', 'Вернутся к настройке', '/page', translatesData)}
                        </div>
                    ) : null}
                    <div className={css.buttonAdminImgText}>
                        {!mobile
                            ? t('pagemanagementButtonSquare-mobile', 'Вернуться к редактированию', '/page', translatesData)
                            : ''}
                    </div>
                </div>
                <div className={css.buttonAdminUnderText}>
                    {!mobile ? t('pagemanagementButtonSquare-mobile', 'Вернуться к редактированию', '/page', translatesData) : ''}
                </div>
            </div>
        </div>
    );
};
export default PreviewButtons;
